<template>
  <section class="section section--elevated">
    <div class="container">
      <h2 class="section-title">应用场景</h2>
      <p class="section-lead">覆盖从创意到生产的全场景算力需求</p>
      <div class="features-grid">
        <div v-for="u in useCases" :key="u.title" class="feature-card">
          <!-- <div class="feature-icon" v-html="u.icon" /> -->
           <div class="feature-tag"></div>
          <h3>{{ u.title }}</h3>
          <p>{{ u.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const useCases = [
  {
    title: '图形渲染',
    desc: '影视后期、3D 动画、建筑可视化等场景的高性能渲染农场，支持 Arnold、V-Ray、Octane 等主流渲染器。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>'
  },
  {
    title: '科学计算',
    desc: '分子动力学模拟、气候模型、流体仿真等 HPC 场景，提供大规模并行计算能力和高速存储系统。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 3h6M10 3v6.5L5 18a3 3 0 002.6 4.5h8.8A3 3 0 0019 18l-5-8.5V3"/><path d="M7.5 14h9"/></svg>'
  },
  {
    title: '大数据处理',
    desc: 'ETL 管道、实时分析、数据仓库等场景，支持 Spark、Flink、Hadoop 等大数据框架。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><ellipse cx="12" cy="5" rx="8" ry="3"/><path d="M4 5v6c0 1.66 3.58 3 8 3s8-1.34 8-3V5"/><path d="M4 11v6c0 1.66 3.58 3 8 3s8-1.34 8-3v-6"/></svg>'
  },
  {
    title: '机器学习训练',
    desc: '传统机器学习模型训练，支持 scikit-learn、XGBoost、LightGBM 等框架，提供分布式训练优化。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 3v18h18"/><path d="M7 14l4-4 4 3 5-6"/></svg>'
  },
  {
    title: '深度学习',
    desc: '计算机视觉、自然语言处理、推荐系统等深度学习任务，支持 PyTorch、TensorFlow 等主流框架。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M9 9h6M9 12h6M9 15h3"/><circle cx="17" cy="15" r="1"/></svg>'
  },
  {
    title: '云游戏',
    desc: '游戏串流、实时渲染、多人在线等场景，提供低延迟、高并发的 GPU 渲染资源。',
    icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 12h4M8 10v4"/><circle cx="16" cy="11" r="1"/><circle cx="18" cy="13" r="1"/><path d="M2 12c0-2.5 1.5-5 5-5h10c3.5 0 5 2.5 5 5s-1.5 5-5 5H7c-3.5 0-5-2.5-5-5z"/></svg>'
  }
];
</script>
<style scoped>
.feature-tag {
  width: 36px;
  height: 4px;
  background: #0095ff;
  margin-bottom: 24px;
}
</style>